import { gql } from '@apollo/client';
import {
  MENU_ITEM_INGREDIENT_FRAGMENT,
  MENU_ITEM_INGREDIENT_METADATA_FRAGMENT,
} from '@/contexts/menu-info-context-queries';

const MENU_ITEM_INGREDIENT_SEARCH_FRAGMENT = gql`
  fragment MenuItemSearch_IngredientFields on menu_item_ingredients {
    ...MenuInfo_MenuItemIngredientFields
    ingredient_metadata
  }

  ${MENU_ITEM_INGREDIENT_FRAGMENT}
  ${MENU_ITEM_INGREDIENT_METADATA_FRAGMENT}
`;

export const MANUAL_MENU_ITEM_INGREDIENT_SEARCH_QUERY = gql`
  query MenuItemSearch_ManualIngredients(
    $locale: String!
    $query: String!
    $restaurantUUID: uuid!
    $skipGroupMemberships: Boolean!
    $skipLiveSalt: Boolean!
    $skipSaltApi: Boolean!
    $useSaltCache: Boolean!
    $supplierUUID: uuid!
  ) {
    searchManualMenuItemIngredients(
      search_text: $query
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
    ) {
      menu_item_ingredient {
        ...MenuItemSearch_IngredientFields
      }
    }
  }
  ${MENU_ITEM_INGREDIENT_SEARCH_FRAGMENT}
`;

export const ALL_MENU_ITEM_INGREDIENT_SEARCH_QUERY = gql`
  query MenuItemSearch_AllIngredients(
    $locale: String!
    $restaurantUUID: uuid!
    $skipGroupMemberships: Boolean!
    $skipLiveSalt: Boolean!
    $skipSaltApi: Boolean!
    $useSaltCache: Boolean!
    $supplierUUID: uuid!
  ) {
    menu_item_ingredients(
      where: {
        restaurant_uuid: { _eq: $restaurantUUID }
        supplier_uuid: { _eq: $supplierUUID }
      }
    ) {
      ...MenuItemSearch_IngredientFields
    }
  }
  ${MENU_ITEM_INGREDIENT_SEARCH_FRAGMENT}
`;
